import { usePublicLanguage } from "../context/PublicLanguage";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import useSEO from "@/hooks/useSEO";
import DailyDishBlock from "@/components/public/DailyDishBlock";
import Newsletter from "@/components/public/Newsletter";

export default function DailyDishPage() {
  const { t } = usePublicLanguage();
  const { data: dish } = useQuery({ queryKey: ["daily"], queryFn: publicApi.dailyDish });
  useSEO({
    title: "The Daily Dish — TechDishes",
    description: "The technology that matters, served daily. Today's key developments in AI and technology.",
    url: window.location.href,
  });

  return (
    <div className="mx-auto max-w-[900px] px-5 md:px-8 py-10 md:py-14">
      <header className="mb-10">
        <div className="td-eyebrow mb-3" style={{ color: "#FF8A1F" }}>{t('Daily Briefing')}</div>
        <h1 className="font-display font-extrabold tracking-tight text-white text-4xl md:text-5xl lg:text-6xl" style={{ letterSpacing: "-0.03em" }}>{t('The Daily Dish')}</h1>
        <p className="mt-4 text-[#A7ABB0] max-w-2xl leading-relaxed" style={{ fontSize: "1.1rem" }}>{t('Five to ten important technology developments you should know today — carefully chosen and clearly explained.')}</p>
      </header>

      <DailyDishBlock dish={dish} />

      <Newsletter />
    </div>
  );
}
